import React, { Component } from "react";
import history from "helper/history";
import i18n from "../i18nNext";
import {
    CustomPrimaryButton as SaveButton,
    CustomSecondaryButton as CancelButton,
    customTertiaryButton as TertiaryButton
} from "../customComponents/components";
import ExtraFieldStores from "../stores/extrafieldstores";
import GenericContainerTypeStore from "../stores/genericContainerTypeStore";
// import * as AutomatedReportAction from "../actions/AutomatedReportAction";
import Common from "../constants/common";
import Icons from "customComponents/icons";
import { isMobile } from "@techsoftware/happay-widgets/CommonFunction/commonFunction";

export default class CommonHeaderCreation extends Component {
    render() {
        let {
            headerText,
            onClose,
            skipGoingBack = false,
            automatedReportId,
            status,
            toggleStatusHandleClick,
            fromPage,
            vendorRegistration,
            vendorRegistrationClick,
            bulkCopyCurrIndex,
            bulkCopyExpenseIDs,
            isBulkCreate,
            editBulkUpload
        } = this.props;
        return (
            <div className="mainheaderClass newHeaderStyle">
                <div
                    className={
                        fromPage == "addVehicles" ? "flex-container-vehicle" : "flex-container"
                    }
                >
                    <div className={`${automatedReportId ? "lowercase" : "uppercase"} headerText`}>
                        {headerText}
                    </div>
                    <div style={{ flex: 1 }}>
                        {automatedReportId && (
                            <div
                                className="flex-end-style margin-lr-20"
                                style={{ alignItems: "center" }}
                            >
                                <div>
                                    {status ? (
                                        <div className="ar-active">Active</div>
                                    ) : (
                                        <div className="ar-inactive">Inactive</div>
                                    )}
                                </div>
                                <div className="flex-vertical-center padding-l-10">
                                    {status ? (
                                        <div
                                            className="ar-action-btns fw-500 font-12 margin-r-30 pointer"
                                            onClick={toggleStatusHandleClick}
                                        >
                                            Deactivate
                                        </div>
                                    ) : (
                                        <div
                                            className="ar-action-btns fw-500 font-12 margin-r-30 pointer"
                                            onClick={toggleStatusHandleClick}
                                        >
                                            Activate
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        {vendorRegistration && (
                            <TertiaryButton
                                label={i18n.t("btn.vendorRegistrationDetails")}
                                onClick={vendorRegistrationClick}
                            />
                        )}
                        {
                            bulkCopyExpenseIDs && bulkCopyCurrIndex ?
                                <div className="padding-10 expense-primary-color">
                                    {bulkCopyCurrIndex} of {bulkCopyExpenseIDs} {Common._flexiDynamicData(
                                        "keyWord_0",
                                        "Expense"
                                    )}
                                </div> :
                                <Icons
                            type="cross"
                            onClick={event => {
                                if(isBulkCreate) {
                                    this.props.onBulkCreateClose.call(this, event);
                                    return;
                                }
                                if (onClose) {
                                    onClose.call(this, event);
                                } else if (
                                    [
                                        "Edit Expense",
                                        "Create Expense",
                                        "Split Expense",
                                        "Edit Report",
                                        "Create Report",
                                        "Create Travel Request",
                                        "EDIT TRAVEL REQUEST"
                                    ].includes(headerText)
                                ) {
                                    ExtraFieldStores.initData();
                                    GenericContainerTypeStore.initialData();
                                }
                                if (!skipGoingBack) {
                                    if (editBulkUpload) {
                                        history.push("/expense");
                                    } else {
                                        history.go(-1);
                                    }
                                }
                            }}
                            interactive
                            size={isMobile ? "small" : "default"}
                        />
                        }
                    </div>
                </div>
            </div>
        );
    }
}
